const domain = window.location.hostname.includes('blackbx.io')
  ? 'blackbx.io'
  : 'stampede.ai'

export default domain
